export const SET_TODOS_FOLDER_PENDING = 'SET_TODOS_FOLDER_PENDING'
export const SET_TODOS_FOLDER = 'SET_TODOS_FOLDER'
export const SET_TODOS_FOLDER_ERROR = 'SET_TODOS_FOLDER_ERROR'
export const SET_TODOS_FOLDER_STRUCTURE_PENDING = 'SET_TODOS_FOLDER_STRUCTURE_PENDING'
export const SET_TODOS_FOLDER_STRUCTURE = 'SET_TODOS_FOLDER_STRUCTURE'
export const SET_TODOS_FOLDER_STRUCTURE_ERROR = 'SET_TODOS_FOLDER_STRUCTURE_ERROR'
